type SessionCardSchedule = {
	day: string;
	monthShort: string;
};

const formatSessionCardMonthShort = (date: Date): string =>
	date
		.toLocaleDateString('pt-BR', { month: 'short' })
		.replace(/\./g, '')
		.slice(0, 3)
		.toLowerCase();

const parseSessionDateLabelToStart = (
	dateLabel?: string | null,
): Date | null => {
	if (!dateLabel?.trim()) return null;

	const match = dateLabel
		.trim()
		.match(/^(\d{2})\/(\d{2})\/(\d{4}),\s*(\d{1,2}):(\d{2})$/);
	if (!match) return null;

	const [, day, month, year, hour, minute] = match;
	const parsed = new Date(
		Number(year),
		Number(month) - 1,
		Number(day),
		Number(hour),
		Number(minute),
	);

	return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const resolveSessionCardSchedule = (
	platformSession?: Sessions.Session | null,
	dateLabel?: string | null,
): SessionCardSchedule | null => {
	let startDate: Date | null = null;

	if (platformSession) {
		const startRaw =
			platformSession.started_at ?? platformSession.selected_date;
		if (startRaw) {
			const parsedStart = new Date(startRaw);
			if (!Number.isNaN(parsedStart.getTime())) {
				startDate = parsedStart;
			}
		}
	}

	if (!startDate) {
		startDate = parseSessionDateLabelToStart(dateLabel);
	}

	if (!startDate) return null;

	return {
		day: String(startDate.getDate()),
		monthShort: formatSessionCardMonthShort(startDate),
	};
};

export { resolveSessionCardSchedule, type SessionCardSchedule };
